import { createContext } from 'react';

export const ServiceDetailsContext = createContext(null);
